const MODULES_TYPES = {
    compromiso: 'Compromiso',
    implementacion: 'Implementación',
    medicion: 'Medición'
}

  
export {MODULES_TYPES}